export const SOFTWARE_PRODUCTS = [
  {
    title: "Eucleia",
    subtitle: "software in cloud per accrescere la reputazione online",
    to: "/software/saas/eucleia",
    filename: "eucleia.png",
  },
  {
    title: "Connect@You",
    subtitle: "servizio di hotspot, WiFi gratuita, facile e sicura",
    to: "/software/saas/connectatyou",
    filename: "connect.png",
  },

  {
    title: "Enma",
    subtitle: "sistema avanzato di controllo accessi",
    to: "/software/saas/enma",
    filename: "enma.png",
  },
  {
    title: "Primo POS",
    subtitle: "smart menu e gestione degli ordini",
    to: "/software/saas/primo",
    filename: "primo.png",
  },
  {
    title: "Book@Me",
    subtitle: "booking engine con channel manager in cloud",
    to: "/software/saas/bookatme",
    filename: "bookatme.png",
  },
]

export const CUSTOM_SOFTWARE = [
  {
    title: "Jova Summer Party 2026",
    subtitle: "L'app ufficiale e Jovagiro, il gioco retro 8 bit",
    to: "/software/custom/jovasummerparty2026",
  },
  {
    title: "Jova Beach Party 2022",
    subtitle: "L'app ufficiale del tour di Jovanotti",
    to: "/software/custom/jovabeachparty2022",
  },
  {
    title: "Pinguini Tattici Nucleari",
    subtitle: "L'app del #machilavrebbemaidetto Tour",
    to: "/software/custom/ptn",
  },
  {
    title: "Jova Beach Party 2019",
    subtitle: "L'app ufficiale del Jova Beach Party Tour",
    to: "/software/custom/jovabeachparty",
  },
  {
    title: "Riccione Christmas Village",
    subtitle: "Il parco tematico dedicato al Natale",
    to: "/software/custom/riccionechristmas",
  },
]

export const NETWORK_PROJECTS = [
  {
    title: "Santuario Santa Rita in Roccaporena",
    subtitle: "Oltre 4.500 metri di minitubo e fibra ottica · Rete dati e TVCC",
    slug: "santuario-santa-rita-roccaporena",
    to: "/infrastrutture-reti/santuario-santa-rita-roccaporena",
    filename: "wifi/roccaporena.jpg",
  },
  {
    title: "Go Gianni Go! 2023",
    subtitle: "Connessione e WiFi per il tour di Gianni Morandi",
    slug: "gogiannigo2023",
    filename: "wifi/gogiannigo.png",
  },
  {
    title: "Castello di Baccaresca",
    subtitle: "Hotel, resort e spa",
    slug: "baccaresca",
    filename: "baccaresca.png",
  },
  {
    title: "Piacere Barbecue",
    subtitle: "Manifestazione gastronomica",
    slug: "piacerebarbecue",
    filename: "barbecue.png",
  },
  {
    title: "Eurochocolate",
    subtitle: "Manifestazione gastronomica",
    slug: "eurochocolate",
    filename: "chocostore.png",
  },
  {
    title: "Rete WiFi Città di Riccione",
    subtitle: "Rete pubblica cittadina",
    slug: "riccione",
    filename: "comunericcione.png",
  },
  {
    title: "Domus Pacis",
    subtitle: "Hotel e centro congressi",
    slug: "domuspacis",
    filename: "domuspacis.png",
  },
  {
    title: "Corona Sunsets Festival",
    subtitle: "Festival",
    slug: "corona",
    filename: "corona.png",
  },
  {
    title: "Ferrara Sharing Festival",
    subtitle: "Meeting economico e finanziario",
    slug: "ferrara",
    filename: "ferrara.png",
  },
  {
    title: "Gluten Free Fest",
    subtitle: "Manifestazione enogastronomica",
    slug: "glutenfreefest",
    filename: "gluten.png",
  },
  {
    title: "Le Befane Shopping Centre",
    subtitle: "Centro commerciale",
    slug: "lebefane",
    filename: "lebefane.png",
  },
  {
    title: "Malto Livello",
    subtitle: "Festival della birra",
    slug: "maltolivello",
    filename: "malto.png",
  },
  {
    title: "Pane Nostrum",
    subtitle: "Manifestazione enogastronomica",
    slug: "panenostrum",
    filename: "panenostrum.png",
  },
  {
    title: "International Motor Days",
    subtitle: "Manifestazione sportiva",
    slug: "motordays",
    filename: "motor.png",
  },
  {
    title: "Todi Appy Days",
    subtitle: "Meeting tecnologico",
    slug: "todiappydays",
    filename: "todi.png",
  },
  {
    title: "Bagno Tiki 26",
    subtitle: "Stabilimento balneare",
    slug: "bagnotiki26",
    filename: "tiki26.png",
  },
  {
    title: "Rossopomodoro",
    subtitle: "Ristorante e pizzeria",
    slug: "rossopomodoro",
    filename: "rossopomodoro.png",
  },
].map(project => ({
  ...project,
  to: project.to || `/infrastrutture-reti/wifi/${project.slug}`,
}))

export const MOBILEPOD = {
  title: "Mobilepod",
  subtitle: "Connessione internet per eventi",
  to: "/infrastrutture-reti/mobilepod",
}

export const SOFTWARE_CATEGORIES = [
  { id: "saas", title: "I nostri prodotti", children: SOFTWARE_PRODUCTS },
  {
    id: "custom",
    title: "APP & Software Personalizzati",
    children: CUSTOM_SOFTWARE,
  },
]

export const NETWORK_CATEGORIES = [
  { id: "mobilepod", title: "Internet per eventi", children: [MOBILEPOD] },
  {
    id: "networks",
    title: "Le nostre infrastrutture reti",
    children: NETWORK_PROJECTS,
  },
]
